export const ip = {
  api: 'https://api.ipify.org',
};
